import * as React from 'react';
import { RouteProps } from 'react-router';
import NonPeriodicInvoicesSyncProvider from './components/common/NonPeriodicInvoicesSyncProvider';
import DirectPaymentUnsuccessful from './components/invoice/notices/DirectPaymentUnsuccessful';
import PaymentProcessingNotice from './components/invoice/notices/PaymentProcessingNotice';
import SuccessNotice from './components/invoice/notices/SuccessNotice';
import WarningNotice from './components/invoice/notices/WarningNotice';
import DirectPayment from './pages/DirectPayment';
import DirectPaymentReturn from './pages/DirectPaymentReturn';
import NotFound from './pages/NotFound';
import PaymentHistory from './pages/PaymentHistory';
import DocumentTitleWrapper from './wrapper/DocumentTitleWrapper';
import LoginNoticeWrapper from './wrapper/LoginNoticeWrapper';

export const INVOICE_DETAILS_PATH = '/detailid';
const INVOICES_TITLE_KEY = 'invoices.header.title';

const getPublicRouteContentWithTitle = (component: React.ReactNode, titleTranslationKey: string) => (
  <DocumentTitleWrapper titleTranslationKey={titleTranslationKey}>{component}</DocumentTitleWrapper>
);

const getPrivateRouteContentWithTitle = (component: React.ReactNode, titleTranslationKey: string) => (
  <DocumentTitleWrapper titleTranslationKey={titleTranslationKey}>
    <LoginNoticeWrapper>{component}</LoginNoticeWrapper>
  </DocumentTitleWrapper>
);

const mapRouteToEtAndRu = (path: string, element: React.ReactNode): RouteProps[] =>
  ['', '/et', '/ru'].map((lang) => ({
    path: `${lang}${path}`,
    element
  }));

export const StaticRoutes: RouteProps[] = [
  ...mapRouteToEtAndRu('/arved', getPrivateRouteContentWithTitle(<NonPeriodicInvoicesSyncProvider />, INVOICES_TITLE_KEY)),
  ...mapRouteToEtAndRu(
    `/arved${INVOICE_DETAILS_PATH}/:invoiceNumber`,
    getPrivateRouteContentWithTitle(<NonPeriodicInvoicesSyncProvider />, INVOICES_TITLE_KEY)
  ),
  ...mapRouteToEtAndRu('/arved/maksete-ajalugu', getPrivateRouteContentWithTitle(<PaymentHistory />, 'payment-history.page-title')),
  ...mapRouteToEtAndRu(
    '/arved/teostatud',
    getPrivateRouteContentWithTitle(
      <NonPeriodicInvoicesSyncProvider componentProps={{ notification: <SuccessNotice translationKey="invoices.notices.payment-successful-notice" /> }} />,
      INVOICES_TITLE_KEY
    )
  ),
  ...mapRouteToEtAndRu(
    '/arved/tootlemisel',
    getPrivateRouteContentWithTitle(<NonPeriodicInvoicesSyncProvider componentProps={{ notification: <PaymentProcessingNotice /> }} />, INVOICES_TITLE_KEY)
  ),
  ...mapRouteToEtAndRu(
    '/arved/tuhistatud',
    getPrivateRouteContentWithTitle(
      <NonPeriodicInvoicesSyncProvider componentProps={{ notification: <WarningNotice translationKey="invoices.notices.payment-unsuccessful-notice" /> }} />,
      INVOICES_TITLE_KEY
    )
  ),
  ...mapRouteToEtAndRu(
    '/arved/kassa/teostatud',
    getPrivateRouteContentWithTitle(
      <NonPeriodicInvoicesSyncProvider componentProps={{ notification: <SuccessNotice translationKey="invoices.notices.pos.payment-successful-notice" /> }} />,
      INVOICES_TITLE_KEY
    )
  ),
  ...mapRouteToEtAndRu(
    '/arved/kassa/tuhistatud',
    getPrivateRouteContentWithTitle(
      <NonPeriodicInvoicesSyncProvider componentProps={{ notification: <WarningNotice translationKey="invoices.notices.pos.payment-cancelled-notice" /> }} />,
      INVOICES_TITLE_KEY
    )
  ),
  ...mapRouteToEtAndRu(
    '/arved/maksan',
    getPrivateRouteContentWithTitle(<NonPeriodicInvoicesSyncProvider componentProps={{ paymentModalOpen: true }} />, INVOICES_TITLE_KEY)
  ),
  ...mapRouteToEtAndRu(
    '/arved/seaded',
    getPrivateRouteContentWithTitle(<NonPeriodicInvoicesSyncProvider componentProps={{ showInvoiceSettings: true }} />, INVOICES_TITLE_KEY)
  ),
  ...mapRouteToEtAndRu('/arved/otsemakse', getPublicRouteContentWithTitle(<DirectPayment />, 'direct-payment.header-title')),
  ...mapRouteToEtAndRu(
    '/arved/otsemakse/teostatud',
    getPublicRouteContentWithTitle(
      <DirectPaymentReturn notification={<SuccessNotice translationKey="invoices.notices.payment-successful-notice" />} />,
      'direct-payment-return.title'
    )
  ),
  ...mapRouteToEtAndRu(
    '/arved/otsemakse/tootlemisel',
    getPublicRouteContentWithTitle(<DirectPaymentReturn notification={<PaymentProcessingNotice />} />, 'direct-payment-return.title')
  ),
  ...mapRouteToEtAndRu('/arved/otsemakse/tuhistatud', getPublicRouteContentWithTitle(<DirectPaymentUnsuccessful />, 'direct-payment-return.title')),
  ...mapRouteToEtAndRu('/arved/otsemakse/tuhistatud', getPublicRouteContentWithTitle(<NotFound />, 'shared.errors.404.title'))
];
